import React from 'react';

import { UseOutletContextInventory } from '../Inventory';
import { StateLanguage } from '../../../../languages/config/StateLanguage';
import { Product } from '../../../../models/product.model';
import { Service } from '../../../../models/service.model';
import { moneyFormat, taxRateFormat } from '../../../../scripts/format.value.script';
import { discountDescription, discountType } from '../../../../libraries/discount.library';

export interface AppInventoryViewDetailProps {
  inventory: string,
  record: any | Service | Product
};

const AppInventoryViewDetail: React.FunctionComponent<AppInventoryViewDetailProps> = ({inventory, record}) => {
  const {companyForUser} = UseOutletContextInventory()
  const {lang} = StateLanguage()

  return (
    <>
      { companyForUser &&
        <table className="table fw-bold gs-0 gy-2 m-0">
          <tbody>
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.description}:</td>
              { inventory === "service" &&
                <td className="min-w-200px">{record.description}</td>
              }
              { inventory === "product" &&
                <td className="min-w-200px">{record.description_short}</td>
              }
            </tr>
            { inventory === "product" &&
              <tr>
                <td className="w-150px text-muted fs-7">{lang.labels.comment}:</td>
                <td className="min-w-200px">{record.description_long.length > 0 ? record.description_long : lang.labels.none}</td>
              </tr>
            }
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.code}:</td>
              <td className="min-w-200px text-capitalize">{record.code.length > 0 ? record.code : lang.labels.none}</td>
            </tr>
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.sku}:</td>
              <td className="min-w-200px text-capitalize">{record.sku.length > 0 ? record.sku : lang.labels.none}</td>
            </tr>
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.codebar}:</td>
              <td className="min-w-200px text-capitalize">{record.codebar.length > 0 ? record.codebar : lang.labels.none}</td>
            </tr>
            { inventory === "product" &&
              <>
              <tr>
                <td className="w-150px text-muted fs-7">{lang.labels.size}:</td>
                <td className="min-w-200px text-capitalize">{record.size.length > 0 ? record.size : lang.labels.none}</td>
              </tr>
              <tr>
                <td className="w-150px text-muted fs-7">{lang.labels.color}:</td>
                <td className="min-w-200px text-capitalize">{record.color.length > 0 ? record.color : lang.labels.none}</td>
              </tr>
              </>
            }
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.unit}:</td>
              <td className="min-w-200px text-capitalize">{record.unit.name}</td>
            </tr>
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.price}:</td>
              <td className="min-w-200px text-nowrap">{companyForUser.currency.symbol} {moneyFormat(record.price)}</td>
            </tr>
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.tax}:</td>
              <td className="min-w-200px text-nowrap">{taxRateFormat(record.tax_rate)}</td>
            </tr>
            <tr>
              <td className="w-150px text-muted fs-7">{lang.labels.discount}:</td>
              <td className="min-w-200px text-capitalize text-nowrap">
                {discountDescription(lang, companyForUser.currency, record.discount)}
                { record.discount.type !== "none" &&
                  <span className="badge badge-light fs-9 text-uppercase ms-2">{discountType(lang, record.discount)}</span>
                }
              </td>
            </tr>
          </tbody>
        </table>
      }
    </>
  )
};

export default AppInventoryViewDetail;
